
<template>
  <v-app id="onNeig">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{neig.neig_num}}  

      <span v-for="(neigtaalRecord,i) in neig.neigtaal" :key="i">
       <br>
       {{neigtaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveNeigtaal(neigtaalRecord)">Save</v-btn><br>
       <v-textarea v-model="neigtaalRecord.neigtaal_oms" :value=neigtaalRecord.neigtaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <v-textarea v-model="neigtaalRecord.neigtaal_website" :value=neigtaalRecord.neigtaal_website rows="1" label="Website titel" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['neig_encrid'],
  data() {
    return {
      neig: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/neig/getNeig.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getNeig"
          },
          getNeig: {
             neig_encrid: this.neig_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.neig = res.data.getNeig;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveNeigtaal(neigtaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/neig/saveNeigtaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveNeigtaal"
          },
          saveNeigtaal: {
            neigtaal: neigtaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveNeigtaal.text,
              color: res.data.saveNeigtaal.color
            });
          }
        })
    }
  }  

};

</script> 
